import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './InvolvedAddressesEvBookingEditor.html?raw';
import lang from 'dojo/_base/lang';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";
import HintBox from '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";

class InvolvedAddressesEvBookingEditor extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;
    private bookingId: string;
    private isNew: boolean = false;

    private input_RelationType: MdsLax<InstanceType<typeof HintBox>>;
    private input_RelationGroup: MdsLax<InstanceType<typeof HintBox>>;
    private input_Address: MdsLax<InstanceType<typeof HintBox>>;

    isValid(): boolean {

        if (this.input_Address.getValue() == null) return false;

        return true;
    }

    setIsNew(isNew: boolean) {

        this.isNew = isNew;
        this.input_RelationType.setReadonly(!this.isNew);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let c_address_1 = this.getAttributeValue("c_address_1");
        let ref_address = this.getAttributeValue("ref_address");
        let c_relation_type = this.getAttributeValue("c_relation_type");
        let ref_relation_type = this.getAttributeValue("ref_relation_type");

        if (c_address_1 && !ref_address) {
            this.input_Address.setValue(c_address_1, true);
        }
        if (c_relation_type && !ref_relation_type) {
            this.input_RelationType.setValue(c_relation_type, true);
        }

        let isReadonly = this.getAttributeValue("tmp_is_readonly");
        if (isReadonly === true) this.setReadonly(isReadonly);
    } 

    externalEventHandler(event: "ok") {

        switch (event) {
            case "ok":
                if (!this.isValid()) {
                    this._showErrorMessage(this.translate("General_Error_InvalidData"));
                    return;
                }
                this._onClicked_OK();
                break;
            default:
                this._showErrorMessage(`Wrong external event! **${event}** event not supported!`)
        }
    }
    private _onClicked_OK() {

        var jsonData = {
            ID: this.entityId,
            changedData: this.changedData
        }

        if (this.isValid()) {
            this.emit("okClicked", jsonData);
        } else {
            this.showToast(this.translate("General_Error_InvalidData"), "fas fa-exclamation-triangle");
        }
    }
    private _onChangeAddress(val: string | VAM2types.Entity_gDisp) {

        if (typeof val == "string") this.setAttributeValue("c_address_1", val);
        else this.setAttributeValue("c_address_1", val.gDisp_1);
    }

    private _onChangeRelationType(val: string | VAM2types.RelationType) {

        if (typeof val == "string") {

            this.setAttributeValue("c_relation_type", val);
            this.setAttributeValue("ref_relation_group", null);
        } else {

            this.setAttributeValue("c_relation_type", val?.description);
            if (val?.ref_relation_group) this.setAttributeValue("ref_relation_group", val?.ref_relation_group);
        }
    }
    private _onChangeRelationGroup(val: VAM2types.Entity_description) {

    }

    applyAllreadyChangedData(data: VAM2types.InvolvedAddressEvBooking) {

        if (this.isNew) this.setData(data);
        else {
            for (let p in data) {
                switch (p) {
                    //case "ref_address":
                    //case "ref_relation_type":
                    //    if (typeof data[p] == "string") {

                    //    }
                    //    break;
                    default:
                        this.setAttributeValue(p, data[p]);
                }
                    
                
            }
        }
    }

    setBookingId(bookingId: string) {

        this.bookingId = bookingId;
    }

    private _onClick_OpenSED(mode, evt) {

        this.loadSelectEntityDialog(evt,
            mode,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }
    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {

        if (!items || !items.length) return;
        let entity = items[0].entry.data;
        switch (mode) {
            case "selectAddress":
                //this.input_Address.setValue(entity);
                this.setAttributeValue("ref_address", entity as VAM2types.Entity_gDisp);
                break;
            case "selectRelationType":
                //this.input_RelationType.setValue(entity);
                this.setAttributeValue("ref_relation_type", entity as VAM2types.RelationType);
                break;
            case "selectRelationGroup":
                this.setAttributeValue("ref_relation_group", entity as VAM2types.Entity_description);
                break;
            default:
                this._showErrorMessage(`Wrong SelectEntityDialogMode - '${mode}''`)
        }
    }
    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API__EvBooking__InvolvedAddressesEvBooking_SED_GetConfig";
        this.input_Address.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectAddress"));
        this.input_RelationType.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectRelationType"));
        this.input_RelationGroup.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectRelationGroup"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(InvolvedAddressesEvBookingEditor);